import { render, staticRenderFns } from "./newPressesionStepThree.vue?vue&type=template&id=10694138&scoped=true&"
import script from "./newPressesionStepThree.vue?vue&type=script&lang=js&"
export * from "./newPressesionStepThree.vue?vue&type=script&lang=js&"
import style0 from "./newPressesionStepThree.vue?vue&type=style&index=0&id=10694138&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10694138",
  null
  
)

export default component.exports